var summerBannerFormJS = (function() {
  var csrf_token,
  railsHost = window.location.protocol + "//" + window.location.hostname;

  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    var custModalOverlay = document.querySelectorAll(".summer-banner__form-trigger");
    var modalContainer = document.querySelector(".summer-banner__popup");
    for (var i = 0; i < custModalOverlay.length; i++) {
      custModalOverlay[i].addEventListener("click", function(e) {
        e.preventDefault();
        var custModalVideo = new tingle.modal({
          onClose: function() {
            //Remove all error element
            var errorMsg = document.querySelectorAll(".error-message");
            for (var i = 0; i < errorMsg.length; i++) {
              errorMsg[i].remove();
            }
            //remove error border class
            var errorMsg = document.querySelectorAll(
              ".error-border"
            );
            for (var i = 0; i < errorMsg.length; i++) {
              errorMsg[i].classList.remove("error-border");
            }
            custModalVideo.destroy();
          }
        });
        custModalVideo.setContent(modalContainer.innerHTML);
        custModalVideo.open();

        //check email validation
        var emailField = custModalVideo.modalBox.querySelector("[name='form-email']"),
        submitBtn = custModalVideo.modalBox.querySelector("[type='submit']");
        checkEmailValidation(emailField, submitBtn);
      });
    }

    var ctaScroll = document.querySelector(".cta-scroll");
    if(ctaScroll) {
      ctaScroll.addEventListener("click", navScroll);
    }
    
    function navScroll(e) {
      e.preventDefault();
      var href = this.getAttribute("href");
      var headerHeight = document.getElementById("header-habitat").offsetHeight - 21;
      var offsetTop = document.querySelector(href).offsetTop - headerHeight;
      bsLib.scrollIt(
        offsetTop,
        1000
      );
    }

    //check email validation
    var emailField = document.getElementById("form-email-new"),
    submitBtn = document.getElementById("commit-new");
    checkEmailValidation(emailField, submitBtn);

    //Floating Btn
    var bannerFloatingBtn = document.getElementById("bannerFloatingBtn"),
    summerBannerSec = document.getElementById("summerBannerSec");
    if (bannerFloatingBtn && summerBannerSec) {
      var summerBannerSec = document.getElementById("summerBannerSec"),
      breakpointFormFooter = document.getElementById("breakpointFormFooter"),
      summerRect = summerBannerSec.getBoundingClientRect(),
      headerHabitat = document.getElementById("header-habitat");

      window.addEventListener("scroll", function() {
        var scrollStartPos = summerRect.bottom - (headerHabitat ? headerHabitat.offsetHeight * 2: 0),
        scrollEndPos = document.body.scrollHeight - window.innerHeight
        - (breakpointFormFooter ? breakpointFormFooter.offsetHeight: 0);

        if (window.pageYOffset > scrollStartPos && window.pageYOffset < scrollEndPos) {
          bannerFloatingBtn.classList.remove("hide");
          bannerFloatingBtn.style.display = "block";
        } else {
          bannerFloatingBtn.classList.add("hide");
        }
      });
    }
  };

  function checkEmailValidation(emailField, submitBtn) {
    //Email fields check 
    if (emailField) {
      //focus 
      emailField.addEventListener('focus', function() {
        var that = this,
        emailError = document.getElementById("email-error");
        
        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        that.classList.remove("error-border");

        if (!csrf_token) {
          // XHR request for user token
          bsLib.ajax(
            "GET",
            railsHost + "/user/token.json",
            {},
            false,
            {},
            // Success message for user token.
            function(data) {
              var dataRequest = bsLib.JSONParse(data.response);
              csrf_token = dataRequest.csrf_token;
            },
            // Custom Error message for user token.
            function() {
              return "user token not working";
            }
          );
        }
      });

      emailField.addEventListener("blur", function(event) {
        var validEmail = true,
        that = this,
        emailError = document.getElementById("email-error");

        //false valid dataset
        that.dataset.notvalid = "0";

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
          validEmail = false;
          
          that.classList.add("error-border");
          that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail: Messages.salesAndSupportPage.invalidEmail) + '</span>');
        } else {
          that.classList.remove("error-border");
        }

        if (validEmail) {
          //Disable submit button
          if (submitBtn) {
            submitBtn.setAttribute("disabled", "disabled");
            submitBtn.dataset.valueText = submitBtn.value;
            submitBtn.value = Messages.salesAndSupportPage.validateText;
          }

          bsLib.ajax(
            "GET",
            railsHost + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value),
            {},
            true,
            {
              "X-CSRF-Token": csrf_token,
              "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
            },
            function(data) {
              var dataRequest = bsLib.JSONParse(data.response);

              //remove disable
              if (submitBtn) {
                submitBtn.removeAttribute("disabled");
                submitBtn.value = submitBtn.dataset.valueText;
              }

              if (dataRequest.valid === false) {
                that.dataset.notvalid = "1";

                that.classList.add("error-border");
                that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
              }
            },
            function() {}
          );
        }
      }); 
    }
  }

  init();
})();

function formValidationNew() {
  
    var ContactForm = {};
    ContactForm.nameField = document.getElementById("form-name-new");
    ContactForm.emailField = document.getElementById("form-email-new");
    ContactForm.companyField = document.getElementById("form-company-new");
  
  
    ContactForm.nameError = document.getElementById("name-error");
    ContactForm.emailError = document.getElementById("email-error");
    ContactForm.phoneError = document.getElementById("phone-error");
  
    function form_validation_new(fieldName, fieldError, errorMessage, isEmail, emailErrorMessage) {

      if (fieldError) {
        fieldError.remove();
      }
  
      if (!isEmail) {
        if (fieldName.value == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="name-error">' + errorMessage + '</span>');
        } else {
          fieldName.classList.remove("error-border");
        }
      } else {
        if (fieldName.value == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + errorMessage + '</span>');
        } else if (!bsLib.validEmail(fieldName.value)) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMessage + '</span>');
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  
    form_validation_new(ContactForm.nameField, ContactForm.nameError, 'please share your name');
    form_validation_new(ContactForm.emailField, ContactForm.emailError, 'please share your email address', true, 'please share your vaild email address');
    form_validation_new(ContactForm.companyField, ContactForm.phoneError, 'please share name of your organization ');
  
    if (ContactForm.nameField.value == "" || ContactForm.emailField.value == "" || !bsLib.validEmail(ContactForm.emailField.value) || ContactForm.companyField.value == "") {
      return false;
    } else if (ContactForm.emailField.dataset.notvalid === "1") { //check valid email from rails api
      if (ContactForm.emailError) {
        ContactForm.emailError.remove();
      }
  
      ContactForm.emailField.classList.add("error-border");
      ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
  
      return false;
    } else {
      if (!Cookie.read("eventsForm_1")) {
        document.body.classList.remove("eventSection-variation");
        Cookie.create("eventsForm_1", "1", 90);
      }
      return true;
    }
  
  }
